export { SORT_TYPES } from './sortTypes';

export const PROMO_CODE_COLUMNS = [
  { id: 'name', label: 'Promo Code', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'promo_type', label: 'Type', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'discount_display', label: 'Discount', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'event_name', label: 'Event / Class', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'venue_name', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'usage', label: 'Usage / Limit', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number', sortField: 'usage_count' },
  { id: 'total_discount', label: 'Total Discount Given', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'revenue_generated', label: 'Revenue Generated', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'currency' },
  { id: 'created_at', label: 'Created', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'status', label: 'Status', alwaysVisible: false, defaultVisible: true, sortable: false },
];

export const getDefaultVisibleColumns = () =>
  PROMO_CODE_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  PROMO_CODE_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
